import cookies from "js-cookie";

export class Cookie {
    constructor( cookieID, expiry, cookieValue ) {
        this.cookieID = cookieID;
        this.cookieValue = cookieValue;
        this.expiry = expiry;
    }

    dropCookie() {
        cookies.set( this.cookieID, this.cookieValue, { expires: this.expiry } );
    }

    deleteCookie() {
        cookies.remove(this.cookieID);
    }

    cookieExists() {
        if( cookies.get( this.cookieID ) != undefined ) {
            return true;
        }
        return false;
    }

    getCookie() {
        return cookies.get(this.cookieID);
    }
}
